import React from 'react';
import { useLang } from '../i18n/LangContext';
import { CONTACT } from '../data/content';
import { Phone, Mail, MessageCircle, MapPin } from 'lucide-react';

export default function Contact() {
  const { t } = useLang();

  const cards = [
    {
      icon: Phone,
      label: t.contact.call,
      value: CONTACT.phone,
      href: `tel:${CONTACT.phoneRaw}`,
    },
    {
      icon: MessageCircle,
      label: t.contact.whatsapp,
      value: CONTACT.phone,
      href: `https://wa.me/${CONTACT.whatsapp}`,
      external: true,
    },
    {
      icon: Mail,
      label: t.contact.email,
      value: CONTACT.email,
      href: `mailto:${CONTACT.email}`,
    },
  ];

  return (
    <div className="grid grid-cols-1 lg:grid-cols-3 gap-4 md:gap-5">
      {cards.map(({ icon: Icon, label, value, href, external }) => (
        <a
          key={label}
          href={href}
          target={external ? '_blank' : undefined}
          rel={external ? 'noopener noreferrer' : undefined}
          className="group p-6 md:p-7 rounded-xl bg-white border border-[#EAE4DA] hover:border-[#606F51] hover:shadow-md transition-all"
        >
          <div className="h-11 w-11 rounded-full bg-[#EFEBDF] group-hover:bg-[#606F51] flex items-center justify-center text-[#606F51] group-hover:text-white transition-colors mb-5">
            <Icon size={20} strokeWidth={1.6} />
          </div>
          <p className="text-[11px] uppercase tracking-[0.24em] text-[#7A7466] mb-2">{label}</p>
          <p className="font-serif text-[#2C2A26] text-xl md:text-[22px] break-words">{value}</p>
        </a>
      ))}
      <div className="lg:col-span-3 mt-4 p-6 md:p-7 rounded-xl bg-[#2C2A26] text-[#FDFBF7] flex flex-col md:flex-row md:items-center justify-between gap-4">
        <div className="flex items-start gap-3">
          <MapPin size={18} className="mt-1 opacity-80" />
          <div>
            <p className="font-serif text-lg md:text-xl">Obach Rural</p>
            <p className="text-white/70 text-sm mt-1">{CONTACT.address}</p>
          </div>
        </div>
        <div className="flex flex-wrap gap-3">
          <a
            href={`https://wa.me/${CONTACT.whatsapp}`}
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center gap-2 px-5 py-3 rounded-full bg-[#25D366] text-white font-medium hover:bg-[#1ebe57] transition-colors"
          >
            <MessageCircle size={16} /> WhatsApp
          </a>
          <a
            href={`tel:${CONTACT.phoneRaw}`}
            className="inline-flex items-center gap-2 px-5 py-3 rounded-full bg-white text-[#2C2A26] font-medium hover:bg-[#F5F0E6] transition-colors"
          >
            <Phone size={16} /> {t.contact.call}
          </a>
        </div>
      </div>
    </div>
  );
}
